import React from "react";
import { Checkbox, Col, Radio, Row } from "antd";
import style from "../../index.module.scss";
import Editor from "components/Editor";
import { RadioProps } from "antd/lib/radio/interface";
import { CheckboxProps } from "antd/lib/checkbox/Checkbox";
import { indexToChar } from "../../../../../../../../../utils/common";

interface QuestionOptionProps {
    index: number;
    id: number;
    type: "checkbox" | "radio";
    showRemove: boolean;
    isRight: boolean;
    value: string;
    onChange: (index: number, text: string) => void;
    onRemove: (index: number) => void;
    error?: string;
}

const QuestionOption = React.memo(function QuestionOption({
    index,
    id,
    type,
    showRemove,
    isRight,
    value,
    onChange,
    onRemove,
    error
}: QuestionOptionProps) {
    const CheckComponent: React.ComponentType<
        (RadioProps & { type: string }) | CheckboxProps
    > = type === "radio" ? Radio : Checkbox;

    function optionChar(index: number) {
        return indexToChar(index);
    }

    return (
        <Row key={index} gutter={[0, 20]}>
            <Col span={4} className={style.label}>
                <i className={style.required}>*</i>
                <CheckComponent
                    name="正确答案"
                    className={style.option}
                    value={id}>
                    选项{optionChar(index)}
                </CheckComponent>
                {isRight && <div className={style.correct}>正确答案</div>}
            </Col>

            <Col span={18} offset={1}>
                <Editor data={value} onChange={text => onChange(index, text)} />

                <div className={style.error}>{error}</div>
            </Col>

            {showRemove && (
                <Col span={1}>
                    <button
                        type="button"
                        className={style.btnDelete}
                        onClick={() => onRemove(index)}
                    />
                </Col>
            )}
        </Row>
    );
});

export default QuestionOption;
